
// this file is automatically generated by version.ts script
export const versions = {
  revision: 'e65d046e731bcb31f7a77afeabed2157cf47a973',
  version: '1.116.0',
};
